var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewish(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2173",
    d: "M0 0h24v24H0z",
    style: {
      fill: "transparent"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2174",
    d: "M12 6a2 2 0 0 0 2-2 1.9 1.9 0 0 0-.29-1.03L12 0l-1.71 2.97A1.9 1.9 0 0 0 10 4a2.006 2.006 0 0 0 2 2zm4.6 9.99-1.07-1.07-1.08 1.07a3.543 3.543 0 0 1-4.89 0l-1.07-1.07-1.09 1.07A3.435 3.435 0 0 1 4.96 17 3.474 3.474 0 0 1 3 16.39V21a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-4.61a3.474 3.474 0 0 1-1.96.61 3.435 3.435 0 0 1-2.44-1.01zM18 9h-5V7h-2v2H6a3 3 0 0 0-3 3v1.54a1.963 1.963 0 0 0 1.96 1.96 1.919 1.919 0 0 0 1.38-.57l2.14-2.13 2.13 2.13a2.006 2.006 0 0 0 2.77 0l2.14-2.13 2.13 2.13a1.936 1.936 0 0 0 1.38.57 1.963 1.963 0 0 0 1.96-1.96V12A2.981 2.981 0 0 0 18 9z",
    style: {
      fill: "#666"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewish);
export default __webpack_public_path__ + "static/media/newish.80ac84c8d8b497f9ac71f34bbb6aa0ea.svg";
export { ForwardRef as ReactComponent };